import { BODY_SHAPE_OPTIONS } from '@/pages/Onboarding/options/BodyShape/BODY_SHAPE_OPTIONS';

export const getDynamicDescription = (
  age: string | null,
  bodyShape: string | null,
  gender: 'male' | 'female' | null,
) => {
  const getAgeCategory = () => {
    if (age === '18-24' || age === '25-34') {
      return 'young';
    } else if (age === '35-49' || age === '50_plus') {
      return 'experienced';
    }
    return 'young';
  };

  const getBodyShapeText = () => {
    if (!bodyShape) return 'athletic';

    const bodyShapeOption = BODY_SHAPE_OPTIONS.find(
      (option) => option.id === bodyShape,
    );
    return bodyShapeOption ? bodyShapeOption.title.toLowerCase() : 'athletic';
  };

  const getGenderText = () => {
    const ageCategory = getAgeCategory();

    if (gender === 'female') {
      return ageCategory === 'young' ? 'girl' : 'woman';
    } else if (gender === 'male') {
      return ageCategory === 'young' ? 'boy' : 'man';
    }

    return ageCategory === 'young' ? 'girl' : 'woman'; // default to female
  };

  const ageText = getAgeCategory();
  const bodyShapeText = getBodyShapeText();
  const genderText = getGenderText();

  return `Just imagine that mysterious vibe with a ${ageText} ${bodyShapeText} ${genderText} that you are going to share a night with...`;
};
